import { openDB } from 'idb';

export default async function logout() {
  await openDB('nupedido', 1).then((db) => {
    db.delete('config', 6);
    window.location.replace(`${window.location.origin}/`);
  });
}
